import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'styles/breakpoints';
import common from 'styles/common';

const Container = styled.div`
  padding: 25px 0;
  width: 100%;
  margin: 45px auto;
  box-shadow: ${common.boxShadow};

  ${media.small`
    width: 650px;
  `};
`;

const Blockquote = styled.blockquote`
  text-align: center;
  font-size: 20px;
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  line-height: 24px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  position: relative;
  width: 80%;
  quotes: '“' '”' '‘' '’';
  margin: 20px auto;
  padding: 30px 20px;

  &:after {
    color: #ccc;
    font-family: Source Sans Pro;
    content: open-quote;
    font-size: 80px;
    position: absolute;
    left: 50%;
    bottom: calc(100% - 20px);
    background: #fff;
    height: 55px;
    width: 55px;
    line-height: normal;
    text-align: center;
    transform: translateX(-50%);
  }
`;

/**
 * Quote component displayed in blocktext
 */
export default function Quote({ text }) {
  if (!text) return null;

  return (
    <Container>
      <Blockquote>
        {text.split('\n').map(paragraph => <p key={paragraph}>{paragraph}</p>)}
      </Blockquote>
    </Container>
  );
}

Quote.propTypes = {
  /** Text to render in the quote box */
  text: PropTypes.string
};

Quote.defaultProps = {
  text: null
};



// WEBPACK FOOTER //
// ./src/components/Quote/Quote.js